import { Component, EventEmitter, Input, Output } from '@angular/core';
import { WFSectionConfig, WFTableConfig } from '../../../workflow';

@Component({
  selector: 'workflow-section',
  templateUrl: './workflow-section.component.html',
  styleUrls: ['./workflow-section.component.scss']
})
export class WorkflowSectionComponent {

  @Input() section!: WFSectionConfig;
  @Input() disabled?: boolean;
  @Input() sectionDropLists!: string[];
  @Input() stepDropLists!: string[];
  @Input() wfTableConfig?: WFTableConfig;

  @Output() delete = new EventEmitter<WFSectionConfig>();
  @Output() duplicate = new EventEmitter<WFSectionConfig>();

  editing?: boolean;


  edit(val: boolean) {
    if (!this.disabled) {
      this.editing = val;
    }
  }


  add() { }

}
